import { getDynamicObject360Label } from './object360Utils';

const { leadControlsConstants, ROUTES_PATH } = require('../constants/globalConstant');

const getDynamicLead360Label = (entityCustomisation, isLeadTypesEnabled) => {
  return isLeadTypesEnabled
    ? leadControlsConstants.OBJECT_TYPE_NAVIGATION_LABEL
    : `${entityCustomisation?.SingularName || leadControlsConstants.DEFAULT_LEAD_LABEL} 360`;
};

export const getDynamicNavigationLabels = (entityCustomisation, leadTypesEnabled) => {
  return {
    [ROUTES_PATH.leadControls]: getDynamicLead360Label(entityCustomisation, leadTypesEnabled),
    [ROUTES_PATH.object360]: getDynamicObject360Label(entityCustomisation, leadTypesEnabled)
  };
};
